import { render } from "./Elk.vue?vue&type=template&id=398d98b1"
import script from "./Elk.vue?vue&type=script&lang=js"
export * from "./Elk.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__